<template>
    <div >
      <div class='s_flex_bian_c m-b-10' v-for="(value,index) in links " :key="index" >
        <span>{{value.name}}</span>
         <a-button type="primary" @click="choose(value)">
            选择
         </a-button>
      </div>
    </div>
</template>

<script>
import { reactive, toRaw, computed, ref, toRefs } from "vue";
export default {
  name:"features",
  setup(pros,{emit}){
    const state= reactive({
      links:[
         {
          name:'宣传视频',
          link:"video",
          key:'video',
          icon:"/web_base_assets/scan/video.png",
        },
         {
          name:'公众号',
          link:"public",
          key:"public",
          icon:'/web_base_assets/scan/logisticsPulice.png'
        },
        {
          name:'会员中心',
          link:"center",
          key:'center',
          icon: '/web_base_assets/scan/logisticsMy.png'
        }
        ,{
          name:'云店',
          link:"/pages/index/index",
          key:'store',
          icon:"/web_base_assets/scan/store_icon.png"
        }
      ]
    })
    const choose=(data)=>{
        emit('select',data)
    }
    return{
      ...toRefs(state),
      choose
    }
  }
}
</script>